import { Controller } from "@hotwired/stimulus"

// Master "Email notifications" checkbox governs the per-type toggles.
// When the user turns the master OFF, the per-type toggles grey out and
// uncheck; turning it back ON restores them to the state they had before.
//
// It only rewrites the checkboxes in response to a user toggle (the `sync`
// action), never on connect — so opening a form that already has the master
// off (e.g. the account page, to change a phone number) just greys the
// toggles without silently unchecking + saving away the stored preferences.
export default class extends Controller {
  static targets = ["master", "dependents"]

  connect() {
    this.applyGrey()
  }

  sync() {
    if (this.masterTarget.checked) {
      this.checkboxes.forEach((cb) => {
        // Restore what they were before the master was switched off. If we have
        // no record (the page loaded with the master already off), default to
        // on — turning email notifications back on should re-enable the emails.
        const prev = cb.dataset.prevChecked
        cb.checked = prev === undefined ? true : prev === "true"
        delete cb.dataset.prevChecked
      })
    } else {
      this.checkboxes.forEach((cb) => {
        cb.dataset.prevChecked = String(cb.checked)
        cb.checked = false
      })
    }
    this.applyGrey()
  }

  applyGrey() {
    this.dependentsTarget.classList.toggle("is-disabled", !this.masterTarget.checked)
  }

  get checkboxes() {
    return Array.from(this.dependentsTarget.querySelectorAll('input[type="checkbox"]'))
  }
}
